module.exports = __webpack_public_path__ + "static/img/img-ptfw3.5ee0958.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-ptfw3.png
// module id = 7egg
// module chunks = 0